module.exports = __webpack_public_path__ + "static/img/coilNoBg.a56e798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coilNoBg.png
// module id = 129
// module chunks = 1